import React from 'react';
import './SongRow.css';

function SongRow({track}) {
    return (
      <div className="song_row">
        <img className="song_row_album" src={track.album.images[0].url} alt={track.album.name} />
        <div className="song_row_info">
          <h1>{track.name}</h1>
          <p>
            {track.artists.map((artist) => artist.name).join(",")}
            {track.album.name}
          </p>
        </div>
      </div>
    );
}

export default SongRow
